import React, { Component } from 'react'

import { ManyChatLogo } from 'components/ManyChatLogo/ManyChatLogo'

import cm from './Logo.module.css'

export default class Logo extends Component {
  render() {
    return (
      <a className={cm.logo} target="_blank" href="https://manychat.com" rel="noreferrer">
        <div className={cm.small}>powered by</div>
        <ManyChatLogo className={cm.icon} />
      </a>
    )
  }
}
